<script setup lang="ts">
  withDefaults(defineProps<{ spanCenter?: number }>(), { spanCenter: 12 });
</script>

<template>
  <div class="grid w-full grid-cols-12 items-start">
    <div :style="{ gridColumn: `${Math.floor((12 - spanCenter) / 2) + 1} / span ${spanCenter}` }">
      <slot />
    </div>
  </div>
</template>
